import { createAsyncThunk } from '@reduxjs/toolkit'
import NotificationsService from '../../systemNotifications/store/services/NotificationsService'
import AlertService from '../core/services/AlertService'
import CartService from '../core/services/CartService'
import PostLoginService from '../core/services/PostLoginService'
import UserService from '../core/services/UserService'

export const getPostLoginThunk = createAsyncThunk(
  'postLogin/GET_POST_LOGIN',
  async (data, { rejectWithValue }) => {
    const response = await PostLoginService.getFirstLogin(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getUserType = createAsyncThunk(
  'user/GET_USER_TYPE',
  async (data, { rejectWithValue }) => {
    const response = await UserService.getUserType(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getFEComponentAuthorized = createAsyncThunk(
  'user/GET_COMPONENT_AUTHORIZED',
  async (_, { rejectWithValue }) => {
    const response = await UserService.getFEComponentAuthorized()
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getCartQuantity = createAsyncThunk(
  'cartAndOrder/getCartQuantity',
  async (_, { rejectWithValue }) => {
    const response = await CartService.getCartQuantity()
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getAlertHighlight = createAsyncThunk(
  'layout/alerts/getAlertHighlight',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.getAlertHighlight(params)
      if (response.success) return response.data
      return rejectWithValue(response.errors)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const getUnreadCount = createAsyncThunk(
  'postLoginLayout/getUnreadCount',
  async (data, { rejectWithValue }) => {
    try {
      const response = await NotificationsService.getUnreadCount(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)
